

import React, { useState } from "react";
import { Transition } from "@headlessui/react";
import { Link } from "react-router-dom";

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const user = JSON.parse( localStorage.getItem("user"))
  const participant = JSON.parse( localStorage.getItem("participant"))

  return (
    <div>
      <nav className="bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between lg:h-20 h-14">

          <div className="flex-shrink-0">
               <Link to='/'> 
               <img
                  className="lg:h-16 lg:w-16 h-12 w-12"
                  src="/logo.png"
                  alt="Workflow"
                />
               </Link>
               
              </div>
            <div className="flex items-center">
           
              <div className="hidden md:block">
                <div className="ml-10 flex items-baseline space-x-4">
                  <a
                    href="/"
                    className=" text-gray-900 hover:bg-gray-100  px-3 py-2 rounded-full text-sm font-medium"
                  >
                    Home
                  </a>
                  <a
                    href="/findevents"
                    className=" text-gray-900 hover:bg-gray-100  px-3 py-2 rounded-full text-sm font-medium"
                  >
                    Find Events
                  </a>
                  <a
                    href="/contact"
                    className=" text-gray-900 hover:bg-gray-100  px-3 py-2 rounded-full text-sm font-medium"
                  >
                    Contact
                  </a>
                  
                  {user?
                   <a
                   href="/profile"
                   className=" text-gray-900 hover:bg-gray-100  px-3 py-2 rounded-full text-sm font-medium"
                 >
                   Profile
                 </a>: 

participant?
<a
href={`/participantprofile/${participant._id}`}
className=" text-gray-900 hover:bg-gray-100  px-3 py-2 rounded-full text-sm font-medium"
>
Profile
</a>: <a
 href="/register"
 className=" text-gray-900 hover:bg-gray-100  px-3 py-2 rounded-full text-sm font-medium"
>
 Register
</a>
                }
                 
                  {
                }
                 

                 
                


                  <a
                    href="/vendorSignup"
                    className="text-purple-500  px-1 py-2 rounded-md text-sm font-medium"
                  >

                  <button class=" px-3 py-2  transition ease-in duration-200 uppercase rounded-full hover:bg-purple-500 hover:text-white border-2 border-purple-300 focus:outline-none">
                       Create Event
                  </button>
                  </a>

                  {!user&&!participant?     <a
                    href="/login"
                    className="text-purple-500   py-2 rounded-md text-sm font-medium"
                  >

                  <button class=" px-3 py-2  transition ease-in duration-200 uppercase rounded-full hover:bg-purple-500 hover:text-white border-2 border-purple-300 focus:outline-none">
                       Login
                  </button>
                  </a>:<></>}
             
                
                </div>
              </div>
            </div>
            <div className="-mr-2 flex flex-col md:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                type="button"
                className=" inline-flex items-center justify-center p-2 rounded-md text-gray-900  focus:outline-none focus:ring-offset-2 "
                aria-controls="mobile-menu"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                {!isOpen ? (
                  <svg
                    className="block h-8 w-8"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                ) : (
                  <svg
                    className="block h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>

        <Transition
          show={isOpen}
          enter="transition ease-out duration-100 transform"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="transition ease-in duration-75 transform"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          {(ref) => (
            <div className="md:hidden" id="mobile-menu">
              <div ref={ref} className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
           
               
                  <a
                    href="/contact"
                    className=" text-gray-900 hover:bg-gray-100  px-3 py-2 rounded-full text-sm font-medium"
                  >
                    Contact
                  </a>

                 
                  <a
                    href="/about"
                    className=" text-gray-900 hover:bg-gray-100  px-3 py-2 rounded-full text-sm font-medium"
                  >
                    About Us
                  </a>
                  
{user?
                   <a
                   href="/profile"
                   className=" text-gray-900 hover:bg-gray-100  px-3 py-2 rounded-full text-sm font-medium"
                 >
                   Profile
                 </a>: <a
                    href="/register"
                    className=" text-gray-900 hover:bg-gray-100  px-3 py-2 rounded-full text-sm font-medium"
                  >
                    Register
                  </a>
                }
                 <a
                    href="/login"
                    className="text-purple-500   py-2 rounded-md text-sm font-medium"
                  >

                  <button class=" px-2 py-1  transition ease-in duration-200 uppercase rounded-full hover:bg-purple-500 hover:text-white border-2 border-purple-300 focus:outline-none">
                       Login
                  </button>
                  </a>
                  <a
                    href="/vendorSignup"
                    className="text-purple-500  px-1 py-2 rounded-md text-sm font-medium"
                  >

                  <button class=" px-2 py-1  transition ease-in duration-200 uppercase rounded-full hover:bg-purple-500 hover:text-white border-2 border-purple-300 focus:outline-none">
                       Create Event
                  </button>
                  </a>
                 
              </div>
            </div>
          )}
        </Transition>
      </nav>

     
    </div>
  );
}

export default Header;